/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} High_Set_Point_TemperatureInputs */



/**
* | output |
* | --- |
* | "Maximum operating setpoint" |
*
* @param {High_Set_Point_TemperatureInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const high_set_point_temperature = /** @type {((inputs?: High_Set_Point_TemperatureInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<High_Set_Point_TemperatureInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Maximum operating setpoint")
	return /** @type {LocalizedString} */ ("Consigne maximum en fonctionnement")
});